import loadable, { DefaultComponent } from '@loadable/component';
import { Spin } from 'antd';
import React from 'react';
import { Redirect, Route, RouteProps, Switch } from 'react-router';
import { PATHS } from 'src/constants/paths';
import { PrivateRoute } from './components/PrivateRoute';

export function loadableWFallback(loadFn: (props: {}) => Promise<DefaultComponent<{}>>) {
  return loadable(loadFn, {
    fallback: (
      <div className="flex items-center justify-center h-screen">
        <Spin />
      </div>
    ),
  });
}
const Exchange = loadableWFallback(() => import('src/pages/exchange'));
const Portfolio = loadableWFallback(() => import('src/pages/portfolio'));
const LiquidityPool = loadableWFallback(() => import('src/pages/liquidity-pool'));
const Referrals = loadableWFallback(() => import('src/pages/portfolio/components/Invite'));
const NotFound = loadableWFallback(() => import('./components/NotFound'));
const AdminLayout = loadableWFallback(() => import('src/pages/admin'));
const TradingLeaderboard = loadableWFallback(() => import('src/pages/trading-leaderboard'));
const TradingCompetition = loadableWFallback(() => import('src/pages/trading-competition'));
const SwapHistories = loadableWFallback(() => import('src/pages/swap/SwapHistories'));
const SwapHistoryDetail = loadableWFallback(() => import('src/pages/swap/SwapHistoryDetail'));
const SwapPage = loadableWFallback(() => import('src/pages/swap'));

const Announcements = loadableWFallback(() => import('src/pages/announcements'));

const LayoutAdminRouter: React.FC<RouteProps> = (props) => {
  return <PrivateRoute {...props} />;
};

const Routes: React.FC = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const referralCode = searchParams.get('referral');

  return (
    <Switch>
      <Route
        exact
        path="/"
        render={() => <Redirect to={PATHS.trade(referralCode ? `referral=${referralCode}` : '')} />}
      />
      <LayoutAdminRouter exact path={`${PATHS.admin()}`} component={AdminLayout} />
      <Route exact path={`${PATHS.trade()}/:pair?`} component={Exchange} />
      <Route exact path={`${PATHS.portfolio()}`} component={Portfolio} />
      <Route exact path={`${PATHS.liquidityPool()}`} component={LiquidityPool} />
      <Route exact path={`${PATHS.announcements()}`} component={Announcements} />
      <Route exact path={`${PATHS.announcements()}/:id`} component={Announcements} />
      <Route exact path={`${PATHS.tradingLeaderboard()}`} component={TradingLeaderboard} />
      <Route exact path={`${PATHS.tradingCompetition()}`} component={TradingCompetition} />
      <Route exact path={`${PATHS.referrals()}`} component={Referrals} />
      <Route exact path={`${PATHS.swap()}`} component={SwapPage} />

      <Route exact path={`${PATHS.swapHistories()}`} component={SwapHistories} />
      <Route exact path={`${PATHS.swapHistoryDetail(':id')}`} component={SwapHistoryDetail} />

      <Route exact path="/:referralCode" component={Exchange} />
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export default Routes;
